export const OPEN_DRAWER_DELAY_MS = 250;
export const LOGIN_STATUS_DELAY_MS = 2000;
